
/* ==========================================
   EROLEN STICKY CART V5
   Dawn + Kaching Bundles
========================================== */

(function () {
  'use strict';

  function init() {
    const bar = document.getElementById('erolen-sticky');

    if (!bar || bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    const stickyButton = bar.querySelector(
      '.erolen-sticky__buy'
    );

    const stickyPrice = bar.querySelector(
      '.erolen-sticky__price'
    );

    const stickyOld = bar.querySelector(
      '.erolen-sticky__old'
    );

    if (!stickyButton || !stickyPrice || !stickyOld) {
      return;
    }

    function getMainButton() {
      return document.querySelector(
        '.product-form__submit'
      );
    }

    function clean(text) {
      return String(text || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    /* READ PRICES FROM EXISTING EROLEN BUTTON */

    function syncPrice() {
      const mainButton = getMainButton();
      if (!mainButton) return;

      const main = mainButton.querySelector(
        '.erolen-button-main'
      );

      const old = mainButton.querySelector(
        '.erolen-button-old'
      );

      if (!main) return;

      const directText = Array.from(main.childNodes)
        .filter(function (node) {
          return node.nodeType === 3;
        })
        .map(function (node) {
          return node.textContent;
        })
        .join(' ');

      const separator = directText.lastIndexOf('·');

      const current = clean(
        separator >= 0
          ? directText.slice(separator + 1)
          : directText.replace(/In den Warenkorb/i, '')
      );

      const previous = old
        ? clean(old.textContent)
        : '';

      if (current) {
        stickyPrice.textContent = current;
      }

      stickyOld.textContent =
        previous && previous !== current
          ? previous
          : '';
    }

    /* CHECK CART DRAWER */

    function isCartOpen() {
      const drawer = document.querySelector('cart-drawer');

      if (drawer) {
        if (
          drawer.classList.contains('active') ||
          drawer.classList.contains('is-open') ||
          drawer.hasAttribute('open') ||
          drawer.getAttribute('aria-hidden') === 'false'
        ) {
          return true;
        }
      }

      const notification = document.querySelector(
        'cart-notification'
      );

      return Boolean(
        notification &&
        (
          notification.classList.contains('active') ||
          notification.hasAttribute('open')
        )
      );
    }

    /* SHOW / HIDE STICKY */

    function syncVisibility() {
      const original = getMainButton();

      if (!original || isCartOpen()) {
        bar.classList.remove(
          'erolen-sticky--visible'
        );
        return;
      }

      const rect = original.getBoundingClientRect();

      bar.classList.toggle(
        'erolen-sticky--visible',
        rect.bottom < 0
      );

      stickyButton.disabled = original.disabled;
    }

    function syncAll() {
      syncPrice();
      syncVisibility();
    }

    /* ORIGINAL BUY ACTION */

    stickyButton.addEventListener('click', function () {
      const original = getMainButton();

      if (!original || original.disabled || isCartOpen()) {
        return;
      }

      original.click();

      setTimeout(syncVisibility, 100);
      setTimeout(syncVisibility, 350);
      setTimeout(syncVisibility, 700);
    });

    /* WATCH MAIN BUTTON */

    let observedButton = null;
    let buttonObserver = null;

    function observeMainButton() {
      const original = getMainButton();

      if (!original || original === observedButton) {
        return;
      }

      if (buttonObserver) {
        buttonObserver.disconnect();
      }

      observedButton = original;

      buttonObserver = new MutationObserver(syncAll);

      buttonObserver.observe(original, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled']
      });

      syncAll();
    }

    /* WATCH CART OPEN/CLOSE */

    const cartObserver = new MutationObserver(
      syncVisibility
    );

    const watched = new WeakSet();

    function watchCart() {
      const elements = [
        document.querySelector('cart-drawer'),
        document.querySelector('cart-notification')
      ];

      elements.forEach(function (element) {
        if (!element || watched.has(element)) return;

        watched.add(element);

        cartObserver.observe(element, {
          attributes: true,
          attributeFilter: [
            'class',
            'open',
            'aria-hidden',
            'style'
          ]
        });
      });
    }

    /* KACHING SELECTION */

    document.addEventListener('change', function (e) {
      if (
        e.target.matches &&
        e.target.matches(
          'input[name="kaching-bundles-deal-"]'
        )
      ) {
        setTimeout(syncAll, 100);
        setTimeout(syncAll, 350);
      }
    });

    document.addEventListener('click', function (e) {
      if (
        e.target.closest &&
        e.target.closest('.kaching-bundles__bar')
      ) {
        setTimeout(syncAll, 100);
        setTimeout(syncAll, 350);
      }
    });

    /* SCROLL / RESIZE */

    window.addEventListener('scroll', syncVisibility, {
      passive: true
    });

    window.addEventListener('resize', syncVisibility, {
      passive: true
    });

    /* CART REPLACEMENT DETECTION */

    const pageObserver = new MutationObserver(function () {
      observeMainButton();
      watchCart();
      syncVisibility();
    });

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    /* STARTUP */

    observeMainButton();
    watchCart();
    syncAll();

    let attempts = 0;

    const startup = setInterval(function () {
      observeMainButton();
      watchCart();
      syncAll();

      attempts++;

      if (attempts >= 40) {
        clearInterval(startup);
      }
    }, 250);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
